import { create } from "zustand"
import { ControlsProps, HoveredLocationProps, LocationProps } from "@/utils/types";
import { CONTROL_TYPES, CONTROLS_DEFAULT } from "@/utils/constants";
import { MapMouseEvent } from "mapbox-gl";
import { getValue, validateNewControlValue } from "@/utils/helpers";

export interface AppStoreProps {
	// Options
	controls: ControlsProps;
	setControls: (controls: object) => void;
	setControl: (type: string, value: string | number) => void;
	showMobileControls: boolean;
	setShowMobileControls: (showMobileControls: boolean) => void;
	// Info
	showMobileMenu: boolean;
	setShowMobileMenu: (showMobileMenu: boolean) => void;
	// Location
	selectedLocation: LocationProps | HoveredLocationProps | null | undefined;
	setSelectedLocation: (selectedLocation: LocationProps | HoveredLocationProps | null | undefined) => void;
	hoveredLocation: HoveredLocationProps | null | undefined;
	setHoveredLocation: (hoveredLocation: HoveredLocationProps | null | undefined) => void;
	hoveredPoint: MapMouseEvent["point"] | null | undefined;
	setHoveredPoint: (hoveredLocation: MapMouseEvent["point"] | null | undefined) => void;
}

export const useAppStore = create<AppStoreProps>()(
	(set, get) => ({
		// Options
		controls: { ...CONTROLS_DEFAULT },
		setControls: (newControls) => {
			let controls = { ...get().controls };
			for(const type of CONTROL_TYPES) {
				controls = validateNewControlValue(
					type,
					getValue(type, newControls),
					controls
				)
			}
			set({
				controls: controls as ControlsProps
			})
		},
		setControl: (type, value) =>
			set(store => {
				const newControls = validateNewControlValue(type, value, store.controls);
				return {
					controls: newControls
				}
			})
		,
		showMobileControls: false,
		setShowMobileControls: showMobileControls => set(() => ({ showMobileControls })),
		// Info
		showMobileMenu: false,
		setShowMobileMenu: showMobileMenu => set(() => ({ showMobileMenu })),
		// Location
		selectedLocation: null,
		setSelectedLocation: (selectedLocation) => set({ selectedLocation }),
		hoveredLocation: null,
		setHoveredLocation: (hoveredLocation) => set({ hoveredLocation }),
		hoveredPoint: null,
		setHoveredPoint: (hoveredPoint) => set({ hoveredPoint }),
	})
);